import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=97aeb782&scoped=true"
import script from "./RecipeDetail.vue?vue&type=script&lang=ts"
export * from "./RecipeDetail.vue?vue&type=script&lang=ts"
import style0 from "./RecipeDetail.vue?vue&type=style&index=0&id=97aeb782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aeb782",
  null
  
)

export default component.exports